// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__1kl7G","row":"Layout_row__A9Pth","col":"Layout_col__+JckB"};